import React from 'react'
import { Navigate, Outlet, useLocation, Link as RouterLink, useOutletContext } from 'react-router-dom'
import { Paper, Stack, Tab, Tabs, Typography } from '@mui/material'
import { usePageTitle } from '../../components/common/PageTitleContext'
import type { AppOutletContext } from '../../app/AppShell'

const prepTabs = [
  { label: 'Prep Categories', value: '/superadmin/prep/categories' },
  { label: 'Ingest Keys (Global)', value: '/superadmin/prep/ingest-keys' },
  { label: 'Prep Feeds', value: '/superadmin/prep/export' },
]

const PrepSheetSettingsPage: React.FC = () => {
  const location = useLocation()
  const appContext = useOutletContext<AppOutletContext>()
  const { includeSuperadmin } = appContext

  usePageTitle('Prep Sheet Settings')

  const activeValue = React.useMemo(() => {
    const match = prepTabs.find((tab) => location.pathname.startsWith(tab.value))
    return match ? match.value : prepTabs[0].value
  }, [location.pathname])

  if (!includeSuperadmin) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="h4" component="h1">
          Prep Sheet Settings
        </Typography>
        <Typography color="text.secondary">
          Manage global prep categories, ingest keys, and prep export URLs for all stations.
        </Typography>
      </Stack>
      <Paper variant="outlined" sx={{ borderRadius: 2 }}>
        <Tabs value={activeValue} variant="scrollable" allowScrollButtonsMobile>
          {prepTabs.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              component={RouterLink}
              to={tab.value}
            />
          ))}
        </Tabs>
      </Paper>
      <Outlet context={appContext} />
    </Stack>
  )
}

export default PrepSheetSettingsPage
